/**
 * Imports only the extensions
 *
 */

import './themes/ui/extensions'
